// extracted by mini-css-extract-plugin
export default {"subtitle":"FormCard_subtitle__B5icj","description":"FormCard_description__O32vo","head":"FormCard_head__WyUW+"};